import { GAME_ROOT } from '../config'
import { Puzzle } from '../types'
import getLocalDate from '../util/getLocalDate'

export default async function fetchDailyPuzzle(date = getLocalDate()) {
	const path = `${GAME_ROOT}/${date}.json`
	const resp = await fetch(path)
	const puzzle: Puzzle = (await resp.json()) as Puzzle
	// At the moment, the puzzles don't have IDs
	puzzle.id = date
	return puzzle
}
